import { render, staticRenderFns } from "./XFilterGroupSettings.vue?vue&type=template&id=7679d6f6"
import script from "./XFilterGroupSettings.vue?vue&type=script&lang=js"
export * from "./XFilterGroupSettings.vue?vue&type=script&lang=js"
import style0 from "./XFilterGroupSettings.vue?vue&type=style&index=0&id=7679d6f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports